import { Radio } from 'antd';
import { Trans } from 'react-i18next';

import { ItemWrapper, Wrapper } from './MasterDegreeRadio.styles';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};

export const MasterDegreeRadio: React.FC<Props> = ({ value, onChange }) => {
  return (
    <Wrapper>
      <ItemWrapper onClick={() => onChange?.(true)} $isSelected={value === true}>
        <Radio checked={value === true} onClick={e => e.preventDefault()}></Radio>
        <span>
          <Trans
            i18nKey={`StudentOnboardingPageTranslations:YES`}
            components={{
              strong: <strong />
            }}
          />
        </span>
      </ItemWrapper>
      <ItemWrapper onClick={() => onChange?.(false)} $isSelected={value === false}>
        <Radio checked={value === false} onClick={e => e.preventDefault()}></Radio>
        <span>
          <Trans i18nKey={`StudentOnboardingPageTranslations:NO`} />
        </span>
      </ItemWrapper>
    </Wrapper>
  );
};
